import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=b0f9a9ea&scoped=true"
import script from "./Tax.vue?vue&type=script&lang=js"
export * from "./Tax.vue?vue&type=script&lang=js"
import style0 from "./Tax.vue?vue&type=style&index=0&id=b0f9a9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f9a9ea",
  null
  
)

export default component.exports